import enUS from "./en-US";
import frFR from "./fr-FR";

export default {
  "en-US": enUS,
  "fr-FR": frFR,
};
